import script from "./LoginDescriptionHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginDescriptionHeader.vue?vue&type=script&setup=true&lang=js"

import "./LoginDescriptionHeader.vue?vue&type=style&index=0&id=761794bc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-761794bc"]])

export default __exports__